import { Page } from '@occc-app/design-system';

type StoredValueDetailsPageProps = {
  title: string;
};

export const StoredValueDetailsPage = ({ title }: StoredValueDetailsPageProps) => {
  return (
    <Page browserTabTitle={title} pageHeaderProps={{ title }} containerProps={{ variant: 'md' }} />
  );
};
